import postieBot from "./images/Postie.png";
import EmmaLogo from "./images/amma-img.png";
import emmaBot from "./images/bot.png";
import dummyUser from "./images/dummy-user.jpg";
import filter from "./images/filter.svg";
import alert from "./images/alert.svg";
import boatDummy from "./images/boatDummy.webp";
import searchIcon from "./images/search.svg";
import sendLogo from "./images/sendLogo.svg";
import searchIcon2 from "./images/search2.svg";
import logoOnship from "./images/onshipDomain/logo-onship.webp";
import poweredText from "./images/powered-text.svg";
import toogleBar from "./images/toogleBar.svg";
import keypadLogo from "./images/keypad.svg";
import frontMLoader from "./images/logo-small.gif";
import dotLoaderGif from "./images/Loft_loading.gif";
import eyeIcon from "./images/eye-icon.svg";
import palCareLogo from "./images/PALCare.png";
import mariAppLogo from "./images/mariAppLogo.svg";
import floatImage from "./images/floatingBot.png";
import HomeLogo from "./images/menu-icons-1.svg";
import FavoriteLogo from "./images/menu-icons-2.svg";
import ActivityLogo from "./images/menu-icons-3.svg";
import ContactLogo from "./images/menu-icons-4.svg";
import GroupLogo from "./images/menu-icons-5.svg";
import MarketplaceLogo from "./images/menu-icons-6.svg";
import searchmobile from "./images/search-icon.svg";
import sendbtn from "./images/send.svg";
import downloadbn from "./images/download.svg";
import menuIcon from "./images/Menu-icon.svg";
import StationSatcomNewLogo from "./images/StationSatcomNewLogo.webp";
import newStationSatcomBGM from "./images/newStationSatcomBGM.webp";
import palCareLoginBGM from "./images/right-login-bg.webp";
import callIcon from "./images/call-icon.png";
import editIcon from "./images/editIcon.svg";
import chatIcon from "./images/chat-icon.svg";
import searchMaind from "./images/search-main-d.svg";
import invite from "./images/get-data.svg";
import profileCamera from "./images/profile-camera.svg";
import closeIcon from "./images/closeIcon.svg";
import myProfileReset from "./images/myprofile_reset.svg";
import downArrow from "./images/downArrow.svg";
import sadCloud from "./images/sad-cloud.png";
import eWallet_plus_icon from "./images/plus-icon@3x.png";
import emptyTable from "./images/emptyTable.png";
import forgotBGBanner from "./images/forgotBGbanner.webp";
import changePasswordBanner from "./images/changePasswordBanner.webp";
import signupRightImg from "./images/register-right-img.webp";
import messageLogo from "./images/message.svg";
import addPlusIcon from "./images/addPlusIcon.svg";
import editGroupLogo from "./images/editGroupLogo.svg";
import exitGroupLogo from "./images/exitGroupLogo.svg";
import resultsNotFound from "./images/resultsNotFound.svg";
import searchResult from "./images/search-result.svg";
import unreadMessage from "./images/unread-msg.svg";
import noFavourites from "./images/no-favourites.svg";
import messageScreenEmpty from "./images/messageScreenEmpty.svg";
import people from "./images/people.svg";
import members from "./images/addMembers.svg";
import options from "./images/option.svg";
import infoicon from "./images/info-icon.svg";
import removeicon from "./images/remove-icon.svg";
import dotsWhite from "./images/whitedots.svg";
import delgroup from "./images/del.svg";
import xcircle from "./images/x-circle .svg";
import groupImg from "./images/thumbnal.svg";
import seamedixsLogo from "./images/seamedixsDomain/seamedixsLogo.svg";
// frontm Domain
import smalllogo from "./images/frontmDomain/smallLogo.webp";
import frontmLogo from "./images/frontmDomain/frontmLogo.webp";
import frontmBanner from "./images/frontmDomain/frontmBanner.webp";
// vikand Domain
import VikandLogo from "./images/vikandDomain/vikandLogo.png";
import vikandLoginBanner from "./images/vikandDomain/vikand_Login_banner.webp";
// seamedix Domain
import seamedixLoginBanner from "./images/seamedixsDomain/seamedixLoginBanner.webp";
// intelsat Domain
import intelsatLogin from "./images/intelsatDomain/IntelsatLogo.png";
import intelsatLoginBanner from "./images/intelsatDomain/IntelsatBGM.webp";
// form fields
import dropdownIcon from "./images/formFieldsIcons/dropdown.png";
import buttonField from "./images/formFieldsIcons/button.png";
import checkboxField from "./images/formFieldsIcons/checkbox.png";
import datePickerDefaultIcon from "./images/formFieldsIcons/date-picker-default-icon.png";
import dateAndTimePickerField from "./images/formFieldsIcons/datepickerIcon.png";
import datePickerField from "./images/formFieldsIcons/date.png";
import emailField from "./images/formFieldsIcons/emailcon.png";
import fileAttachmentField from "./images/formFieldsIcons/fileAttachment.png";
import calenderIcon from "./images/formFieldsIcons/icon-cl.png";
import multiSelectField from "./images/formFieldsIcons/multiSelect.png";
import radioButtonField from "./images/formFieldsIcons/radioButton.png";
import searchInputField from "./images/formFieldsIcons/serachinput.png";
import textAreaField from "./images/formFieldsIcons/textArea.png";
import textField from "./images/formFieldsIcons/textIcon.png";
import uploadImageField from "./images/formFieldsIcons/uploadImage.png";
import uploadVideoField from "./images/formFieldsIcons/uploadVideo.png";
import radioBtnIcon from "./images/radioBtnIcon.png";

export const ImagePath = {
  postieBot,
  EmmaLogo,
  emmaBot,
  dummyUser,
  filter,
  alert,
  boatDummy,
  searchIcon,
  sendLogo,
  searchIcon2,
  logoOnship,
  poweredText,
  toogleBar,
  keypadLogo,
  frontMLoader,
  dotLoaderGif,
  eyeIcon,
  palCareLogo,
  mariAppLogo,
  floatImage,
  HomeLogo,
  FavoriteLogo,
  ActivityLogo,
  ContactLogo,
  GroupLogo,
  MarketplaceLogo,
  searchmobile,
  sendbtn,
  downloadbn,
  menuIcon,
  StationSatcomNewLogo,
  newStationSatcomBGM,
  palCareLoginBGM,
  callIcon,
  editIcon,
  chatIcon,
  searchMaind,
  invite,
  profileCamera,
  closeIcon,
  myProfileReset,
  downArrow,
  sadCloud,
  eWallet_plus_icon,
  emptyTable,
  forgotBGBanner,
  changePasswordBanner,
  signupRightImg,
  messageLogo,
  addPlusIcon,
  editGroupLogo,
  exitGroupLogo,
  resultsNotFound,
  searchResult,
  unreadMessage,
  noFavourites,
  messageScreenEmpty,
  people,
  members,
  options,
  infoicon,
  removeicon,
  dotsWhite,
  delgroup,
  xcircle,
  groupImg,
  seamedixsLogo,
  // frontm Domain
  smalllogo,
  frontmLogo,
  frontmBanner,
  // vikand Domain
  VikandLogo,
  vikandLoginBanner,
  // seamedix Domain
  seamedixLoginBanner,
  // intelsat Domain
  intelsatLogin,
  intelsatLoginBanner,
  // form fields
  dropdownIcon,
  buttonField,
  checkboxField,
  datePickerDefaultIcon,
  dateAndTimePickerField,
  datePickerField,
  emailField,
  fileAttachmentField,
  calenderIcon,
  multiSelectField,
  radioButtonField,
  searchInputField,
  textAreaField,
  textField,
  uploadImageField,
  uploadVideoField,
  radioBtnIcon,
};